/**
 * Select an integer representation for engagement values.
 */
Beef.module("OtsPicker").addInitializer(function(startupOptions) {

    this.View = Beef.IntegerPicker.View.extend({
        attribute: 'ots'
    });

    this.converter = Beef.IntegerPicker.createConverter("Followers / Opportunity-to-See", 'OTS');

    this.attach = function(view, selector, attribute, options) {
        Beef.IntegerPicker.attachPicker(view, selector, attribute, this.View, options);
    };

});
